import Link from 'next/link'
import Head from 'next/head'
import { PersonalTrainerHead } from '../../../components/index/service-category/personal-trainer/PersonalTrainerHead'
import { TrainerByType } from '../../../components/index/service-category/personal-trainer/TrainerByType'
import { TrainerByFitnessType } from '../../../components/index/service-category/personal-trainer/TrainerByFitnessType'
import { openModal } from 'service/modal-service'
import { RequestProvider } from 'context/RequestContext'
import { PersonalTrainerBooking } from '../../../components/index/service-category/personal-trainer/PersonalTrainerBooking'
import { FaDumbbell, FaUsers } from 'react-icons/fa'
import Script from 'next/script'
import { useState } from 'react'
import { getArticleDateTime } from '../../../utils/article-date-time'
import { getRequestJSON } from '../../../api/index/location-api'
import { s3Static } from '../../../utils/constants'
import Image from 'next/image'

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {

    const { modifiedDate, month, year } = getArticleDateTime();

    const countryName = "Singapore"

    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        requestCategorySettings,
        countryName,
        modifiedDate,
        year
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function TrainerType(props) {
    const requestCategorySettings = props.requestCategorySettings
    const modifiedDate = props.modifiedDate
    const year = props.year

    const [requestForm, setRequestForm] = useState(true)
    const requestType = "Fitness Trainer"
    const [isQuickBook, setIsQuickBook] = useState(false)
    const [isCustomBook, setIsCustomBook] = useState(false)

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
    }

  return (
    <>
      <Head>
        <title>Type of Personal Trainers in Singapore - Find Your Perfect Match</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description"
            content="Discover different types of personal trainers in Singapore. From beginner to elite coaches, find trainers by experience level, fitness goals, and training style. Book certified trainers today."/>
        <meta name="keywords"
            content="types of personal trainers singapore, personal trainer experience levels, fitness trainer types, beginner personal trainer, elite coach singapore"/>
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification"
            content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"  content={`https://www.stringssg.com/sg/personal-trainer/trainer-types`} />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content="Type of Personal Trainers in Singapore - Find Your Perfect Match"/>
        <meta property="og:description" content="Discover different types of personal trainers in Singapore. From beginner to elite coaches, find trainers by experience level, fitness goals, and training style. Book certified trainers today."/>
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-06T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/personal-trainer/female-personal-trainer-training-girl-at-gym.jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@stringssg"/>
        <meta name="twitter:url" content={`https://www.stringssg.com/sg/personal-trainer/trainer-types`}/>
        <meta name="twitter:title" content="Type of Personal Trainers in Singapore - Find Your Perfect Match"/>
        <meta name="twitter:description" content="Discover different types of personal trainers in Singapore. From beginner to elite coaches, find trainers by experience level, fitness goals, and training style. Book certified trainers today."/>
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/personal-trainer/female-personal-trainer-training-girl-at-gym.jpeg" />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/trainer-types" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Type of Personal Trainers in Singapore",
              "description": "Discover different types of personal trainers in Singapore. From beginner to elite coaches, find trainers by experience level, fitness goals, and training style. Book certified trainers today.",
              "provider": {
                "@type": "Organization",
                "name": "StringsSG",
                "url": "https://www.stringssg.com",
                "sameAs": ["https://www.facebook.com/StringsSG/"]
              },
              "areaServed": "Singapore",
              "url": "https://www.stringssg.com/sg/personal-trainer/trainer-types"
            })
          }}
        />
      </Head>
        <div className="">
            <RequestProvider>
                <PersonalTrainerHead
                    heroImage={s3Static + "personal-trainer/female-personal-trainer-training-girl-at-gym.jpeg"}
                    title="Type of Personal Trainers in Singapore"
                    heading="Type of Personal Trainers in Singapore"
                    heroCopy="Compare trainer types, experience tiers and specialisms so you can match the right coach to your goal."
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    isCustomBook={isCustomBook}
                    requestType={requestType}
                    requestCategorySettings={requestCategorySettings}
                />

                <header className="text-center py-8 px-2">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Type of Personal Trainers in Singapore</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">With StringsSG, find the perfect personal trainer in Singapore by type, experience level, and fitness goals. From beginner to elite coaches, book certified trainers today.</p>
                    <p className="text-base text-gray-600 max-w-3xl mx-auto mt-4">
                        Each type of trainer carries a different price tag. See{' '}
                        <Link href="/sg/personal-trainer/personal-trainer-rates-singapore" prefetch={false} className="text-orange-600 hover:text-orange-700 underline">
                            personal trainer rates in Singapore by experience and certification
                        </Link>{' '}
                        before you decide which tier fits your goal and budget.
                    </p>
                </header>

                <section className="max-w-6xl mx-auto py-12 px-4">
                    <div className='pt-5' id="trainer-by-type" aria-labelledby="trainer-by-type">
                        <article>
                            <div className="flex justify-center items-center gap-4 mb-4">
                                <FaUsers className="w-8 h-8 text-amber-500" />
                                <h2 className='text-center text-xl md:text-2xl uppercase'>
                                    <strong>Trainer By Type</strong>
                                </h2>
                            </div>
                            <p className="leading-relaxed text-center text-gray-700 max-w-2xl mx-auto">
                                Choose your training style:
                                <span className="font-medium">one-on-one coaching</span>,
                                <span className="font-medium">small group classes</span>,
                                or <span className="font-medium">at-home convenience</span>.
                                You&apos;ll also find <span className="font-medium">female trainers</span> and
                                <span className="font-medium"> specialists for seniors</span>.
                            </p>
                            <TrainerByType />
                        </article>
                    </div>
                </section>

                <section className='max-w-6xl mx-auto my-10' id="trainer-by-experience" aria-labelledby="trainer-by-experience">
                    <div className='p-2'>
                        <h2 className='text-center text-xl md:text-2xl uppercase'>
                            <strong>Trainer By Experience</strong>
                        </h2>
                    </div>
                    <div className='pt-2 text-sm leading-7 space-y-5'>
                        <div className='relative w-full h-96 md:h-120'>
                            <Image
                                src={s3Static + "personal-trainer/personal-trainer-plan.png"}
                                fill
                                style={{objectFit: 'cover', objectPosition: 'center'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Personal Trainer Singapore Experience Levels - Beginner, Intermediate, Elite Coaches | StringsSG'
                                sizes="(max-width: 768px) 50vw, 75vw"
                            />
                        </div>

                        <div className='md:grid md:grid-cols-4 border border-slate-200 rounded-lg gap-5 p-5'>
                            <div className='md:col-span-1 p-2 flex flex-col justify-center items-center text-center'>
                                <div className='text-4xl rounded-full w-15 h-15 flex items-center justify-center text-white bg-linear-to-tr from-yellow-600 to-yellow-400 shadow-lg mb-2'>
                                    🌱
                                </div>
                                <h3 className='text-base uppercase'><strong>Beginner Trainer</strong></h3>
                            </div>
                            <p className='md:col-span-3 py-2'>
                                Perfect for newcomers in Singapore taking their first steps into fitness. Beginner trainers, with 1-5 years of experience, focus on building proper form, foundational strength, and healthy habits. They guide clients through simple but effective workouts, helping you improve cardiovascular health, build confidence, and establish sustainable routines. Sessions are safe, approachable, and designed to give you consistent progress without overwhelming you.
                            </p>
                        </div>

                        <div className='md:grid md:grid-cols-4 border border-slate-200 rounded-lg gap-5 p-5'>
                            <div className='md:col-span-1 p-2 flex flex-col justify-center items-center text-center'>
                                <div className='text-4xl rounded-full w-15 h-15 flex items-center justify-center text-white bg-linear-to-tr from-purple-600 to-pink-400 shadow-lg mb-2'>
                                    ⚡
                                </div>
                                <h3 className='text-base uppercase'><strong>Intermediate Trainer</strong></h3>
                            </div>
                            <p className='md:col-span-3 py-2'>
                                Ideal for those who have some fitness experience and want to take their training further. Intermediate trainers, with 5-9 years of professional experience, craft programs that balance strength, cardio, and functional exercises. They help clients build muscle tone, improve endurance, and develop proper training techniques. Perfect for Singapore residents aiming for visible results, a more sculpted physique, or higher functional fitness with structured guidance and motivation.
                            </p>
                        </div>

                        <div className='md:grid md:grid-cols-4 border border-slate-200 rounded-lg gap-5 p-5'>
                            <div className='md:col-span-1 p-2 flex flex-col justify-center items-center text-center'>
                                <div className='text-4xl rounded-full w-15 h-15 flex items-center justify-center text-white bg-linear-to-tr from-green-600 to-lime-400 shadow-lg mb-2'>
                                    👑
                                </div>
                                <h3 className='text-base uppercase'><strong>Elite Coach</strong></h3>
                            </div>
                            <p className='md:col-span-3 py-2'>
                                For serious fitness enthusiasts seeking complete transformation. Elite coaches, with 10+ years of experience, provide advanced programs that include complex training regimens, sports-specific conditioning, and body recomposition. Whether you&apos;re an athlete, fitness model, or simply aiming for peak performance, these coaches deliver highly personalized guidance, pushing boundaries safely while helping clients achieve exceptional results in both health and physique.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="max-w-6xl mx-auto py-12 px-4">
                    <div className="pt-5" id="trainer-by-goal" aria-labelledby="trainer-by-goal">
                        <article>
                            <div className="flex justify-center items-center gap-3 mb-6">
                                <FaDumbbell className="w-8 h-8 text-amber-500" />
                                <h2 className='text-center text-xl md:text-2xl uppercase'>
                                    <strong>Trainer By Fitness Goal</strong>
                                </h2>
                            </div>
                            <TrainerByFitnessType />
                        </article>
                    </div>
                </section>
            
                <PersonalTrainerBooking
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    year={year}
                />
            </RequestProvider>
        </div>
        <Script
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-QD1HGGHDYJ');
          }}
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '128634041116395');
                fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
